<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import FunctionAccessForm from "../../../components/settings/functionaccess/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": FunctionAccessForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('rechruserfunctionaccess.newhruserfunctionaccesscntrl'),
      pageTitleValue: "",
      formData: {
        hrUserid: null,
        secuserid: null,
        userid: this.$store.getters.userId,
        functionlist: {},
        functionkey: [],
        groupvalue: [],
        stamp: 0,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      if (vm.formData.hrUserid != null) {
        this.$store.dispatch('post', {url: "/functionaccess/create", payload: this.formData})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "functionaccesslist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    cancelHandler() {
      this.$router.push({ name: "functionaccesslist" });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },
  },
};
</script>